<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">
                <gj-country-server-select
                        v-model="filter.countryMarketValue"
                >
                </gj-country-server-select>

                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'asin', text: 'ASIN'},
                       {id: 'msku', text: 'MSKU'},
                       {id: 'replacementOrderId', text: '订单编号'},
                       {id: 'originalOrderId', text: '原订单编号'}
                   ]"
                >
                </gj-select-input>

                <gj-date-picker
                        type="daterange"
                        v-model="filter.date"/>

                <template #right>
                    <gj-tool-group
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :sort-gjtable="$refs.gjTable"
                            :download="$permission('replacementOrder:export')" download-url="/operation/replacementOrder/export"
                            :download-params="globalParams"
                            help
                    >
                    </gj-tool-group>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    :default-sort="{prop: 'impressions', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
                <template v-slot:asin="{row}">
                    <gj-tooltip :text-line="1" :content="row.listingTitle">
                        {{row.listingTitle | defaultShow}}
                    </gj-tooltip>
                    <el-row>
                        <el-col :span="10">
                            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                            <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
                        </el-col>
                        <el-col :span="14">
                            <div class="text-ellipsis-1">
                                {{row.msku | defaultShow}}
                                <gj-copy-icon v-if="isMeaningful(row.msku)" :content="row.msku"/>
                            </div>
                        </el-col>
                    </el-row>
                </template>
                <template v-slot:sku="{row}">
                    <gj-tooltip :text-line="1" :content="row.skuName" v-if="row.sku">
                        {{row.skuName | defaultShow}}
                    </gj-tooltip>
                    <el-row type="flex">
                        <RelateProductComponent :data="row" />
                    </el-row>
                </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {isMeaningfulMixin, queryMixin} from "@/minxins";
    import {isMeaningful} from "@/utils/common";
    import {
        exportReplacementOrder,
        getReplacementOrderPage
    } from "@/api/sale";
    import {convertToDate} from "@/utils/date.util";
    import { RelateProductComponent }from '@/views/components/relate-product/index'
    export default {
        name: "app-replacementOrder",
        mixins: [queryMixin, isMeaningfulMixin],
        components: {
            RelateProductComponent
        },
        data() {
            return {
                tableName: 'replacementOrder',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    // {marketName: 'aa', asin: 'asin1'}
                    {id: 'marketName', header: '店铺/国家', field: 'marketName', minWidth: '120px', default: true, disabled: true},
                    {id: 'replacementOrderId', header: '订单编号', field: 'replacementOrderId', minWidth: '150px', default: true},
                    {id: 'originalOrderId', header: '原订单编号', field: 'originalOrderId', minWidth: '150px', default: true},
                    {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true},
                    {id: 'asin', header: '商品标题/ASIN/MSKU', field: 'slot:asin', minWidth: '300px', default: true},
                    {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', default: true},
                    {id: 'shipmentMarketDate', header: '发货时间', field: 'shipmentMarketDate', sortable: true, minWidth: '160px', help: '市场时间', default: true},
                    {id: 'fulfillmentCenterId', header: '亚马逊仓库代码', field: 'fulfillmentCenterId', minWidth: '110px', default: true},
                    {id: 'quantity', header: '数量', field: 'quantity', sortable: true, minWidth: '90px', align: 'right', default: true},
                    {id: 'replacementReasonDesc', header: '换货原因', field: 'replacementReasonDesc', minWidth: '120px', default: true}
                ],
                tableData: [],
                filter: {
                    countryMarketValue: null,
                    keyword: {
                        key: 'asin', value: null,
                    },
                    date: null
                },
                treeData: [{
                    id: 0, label: '00'
                }],
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                cacheOptions: {
                    useCache: true,
                }
            }
        },
        created() {
            this.sort.prop = null;
        },
        methods: {
            $gjQueryInitParams() {
                try {
                    let { param = '' } = this.$route.query

                    param = JSON.parse(param)
                    return {
                        filter: {
                            countryMarketValue: {
                                countryIds: param.countryCodes,
                                marketIds: param.marketIds
                            },
                            keyword: {
                                key: 'asin', value: param.asinCode,
                            },
                            date: [param.startDateTime || '', param.endDateTime || '']
                        }
                    };

                } catch (e) {
                    return {
                        filter: {
                            countryMarketValue: null,
                            keyword: {
                                key: 'asin', value: null,
                            },
                            date: null
                        }
                    };
                }
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{countryMarketValue: *}}
             */
            $gjCacheCallback(params) {
                return {
                    countryMarketValue: params.countryMarketValue
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {
                        startMarketTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
                        endMarketTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                // 关键词查询
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                // 店铺国家
                if (this.filter.countryMarketValue) {
                    params.model.countrys = this.filter.countryMarketValue.countryIds;
                    params.model.marketIds = this.filter.countryMarketValue.marketIds;
                }
                this.globalParams = params;
                // 查询
                this.loading = true;
                getReplacementOrderPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            download() {
                exportReplacementOrder(this.globalParams);
            }
        },
    }
</script>

<style scoped>

</style>
